import React, { PureComponent } from 'react';
import { string } from 'prop-types';
import { TOS_FINANCIAL_URL } from '../../constants';
import Link from '../Link';

export default class FinancialRelationship extends PureComponent {
  static propTypes = {
    className: string,
  };

  render = () => (
    <Link className={this.props.className} to={TOS_FINANCIAL_URL}>
      Financial Relationships
    </Link>
  );
}
